import { render, staticRenderFns } from "./cause.vue?vue&type=template&id=386973b0&scoped=true&"
import script from "./cause.vue?vue&type=script&lang=js&"
export * from "./cause.vue?vue&type=script&lang=js&"
import style0 from "./cause.vue?vue&type=style&index=0&id=386973b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386973b0",
  null
  
)

export default component.exports